import { Navbar } from "../Navbar";
import { BlockBox, LoaderImg, LoaderWrapper } from "./style";

export const LoaderComp = () => {
  return (
    <LoaderWrapper>
      <Navbar />
      <LoaderImg />
      <BlockBox />
    </LoaderWrapper>
  );
};
